import '@fontsource/vazirmatn/400.css';
import '@fontsource/vazirmatn/500.css';
import '@fontsource/vazirmatn/700.css';
import '@fontsource/vazirmatn/800.css';
import './styles.css';
import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { ApiError, setSessionLostHandler } from '@/api/client';
import App from './App.vue';
import { router } from './router';
import { useAuthStore } from './stores/auth';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      // Don't hammer the API on auth/permission/validation errors.
      retry: (count, e) => !(e instanceof ApiError && e.status >= 400 && e.status < 500) && count < 2,
    },
  },
});

const app = createApp(App).use(createPinia()).use(VueQueryPlugin, { queryClient });

setSessionLostHandler(() => {
  useAuthStore().sessionLost();
  queryClient.clear();
  const current = router.currentRoute.value;
  if (!current.meta.public) void router.replace({ name: 'login', query: { redirect: current.fullPath } });
});

app.use(router).mount('#app');
